import { httpsCallable } from 'firebase/functions';
import { functions } from '../config';

/**
 * ファイル出力リクエストの型定義
 */
export interface ExportFileRequest {
  history_id: string; // フロントエンドで作成した履歴ID
  file_content: string; // Base64エンコードされたファイル内容
  file_size: number;
  encoding?: 'utf8' | 'sjis';
  result_ids?: string[]; // 出力対象の result_id 配列（Webhook ペイロード用）
  result_count?: number; // 出力対象件数（result_ids.length と同じ。明示用）
}

/**
 * ファイル出力レスポンスの型定義
 */
export interface ExportFileResponse {
  success: boolean;
  history_id: string;
  file_path: string;
}

/**
 * ファイル出力を実行
 * フロントエンドで作成された履歴に対してファイルをStorageにアップロード
 */
export const exportFile = async (request: ExportFileRequest): Promise<ExportFileResponse> => {
  const callable = httpsCallable<ExportFileRequest, ExportFileResponse>(functions, 'exportFile');
  const result = await callable(request);
  return result.data;
};
